"use client";

import { NextIntlClientProvider } from "next-intl";
import React from "react";
import { handleIntlMessageFallback } from "utils";

interface ISessionProviderProps {
  children?: React.ReactNode;
  locale: any;
  messages: any;
}

export default function IntlProvider({
  children,
  locale,
  messages,
}: ISessionProviderProps) {
  return (
    <NextIntlClientProvider
      locale={locale}
      messages={messages}
      timeZone="Europe/Budapest"
      getMessageFallback={handleIntlMessageFallback}
    >
      {children}
    </NextIntlClientProvider>
  );
}
